import { Flex, Text } from '@chakra-ui/react';

export default function CurrencyAvatar({ name, size = 36, isInactive = false }) {
  const label = name || '';
  const fontSize = label.length <= 3 ? size * 0.36 : size * 0.3;

  return (
    <Flex
      w={`${size}px`}
      h={`${size}px`}
      borderRadius="full"
      bg="redesign.bg.card"
      color="redesign.heading"
      align="center"
      justify="center"
      flexShrink={0}
      opacity={isInactive ? 0.5 : 1}
    >
      <Text
        fontSize={`${fontSize}px`}
        fontWeight={600}
        lineHeight={1}
        letterSpacing="-0.02em"
      >
        {label}
      </Text>
    </Flex>
  );
}
